<section class="bg-surface-100 dark:bg-surface-950 px-6 md:px-12 lg:px-20 py-20">
	<div class="flex flex-col lg:flex-row items-center gap-20">
		@if (content.image){
		<div
			pAnimateOnScroll
			enterClass="animate-enter fade-in-10 slide-in-from-l-8 animate-duration-1000"
			leaveClass="animate-leave fade-out-0"
			class="w-full lg:w-1/2 shadow-md border-10 border-white">
			<img
				loading="lazy"
				[src]="content.image.src"
				[alt]="content.image.alt"
				class="w-full object-cover" />
		</div>
		}
		<div
			class="w-full lg:w-1/2 flex flex-col gap-8"
			pAnimateOnScroll
			enterClass="animate-enter fade-in-10 slide-in-from-r-8 animate-duration-1000"
			leaveClass="animate-leave fade-out-0">
			<div class="flex flex-col gap-4">
				<app-headline-large [title]="content.title"></app-headline-large>
				<app-body-large [description]="content.description"></app-body-large>
			</div>
			@if (content.copy.length > 0){
			<div class="flex flex-col gap-2">
				@for (item of content.copy; track item.title) {
				<div class="flex items-center gap-4 p-2">
					<i class="pi pi-check-circle text-primary-500 dark:text-primary-400 text-xl!"></i>
					<div class="flex flex-col gap-1">
						@if (item.title.length > 0){
						<h3
							class="text-base text-surface-900 dark:text-surface-0 font-medium leading-normal"
							[innerHTML]="item.title"></h3>
						} @if (item.description.length > 0){
						<p
							class="text-base text-surface-700 dark:text-surface-400 leading-normal"
							[innerHTML]="item.description"></p>
						}
					</div>
				</div>
				}
			</div>
			} @if (content.link){
			<app-link
				[type]="content.link.type"
				[routerLink]="content.link.path"
				[label]="content.link.title"
				bgColor="light"></app-link>
			}
		</div>
	</div>
</section>
